import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TemplateElementComponent } from '../template-element.component';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-template-list-element',
  templateUrl: './template-list-element.component.html',
  styleUrls: ['./template-list-element.component.scss', '../../../global-workspace-styles.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButtonModule, RouterModule, MatTooltipModule, CommonModule]
})
export class TemplateListElementComponent extends TemplateElementComponent {}
